module.exports = new __parcel__URL__("BrickFest.f3cba0ca.avif").toString();